export default [planningStoreService]

function planningStoreService() {}
